<template>
	<v-app>
		<v-content>
			<v-container class="fill-height" fluid>
				<div class="rule">
					<h1>プライバシーポリシー</h1>
					<dl class="dl-block">
						<p>
							この規約（以下「本規約」といいます）は、{{shop_name}}（以下「当社」といいます）が提供するスマートフォン（以下「端末機」といいます）向けの公式アプリ（以下「本アプリ」といいます）のすべてのサービス（以下「本サービス」といいます）の利用に関する条件を、本サービスを利用するお客様（以下「お客様」といいます）と当社との間で定めるものです。
						</p><br>

						<dt>1. 個人情報の取扱いについて</dt>
						<dd>
							当社は、個人情報の取り扱いに関し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び関連する政令、規則、ガイドライン等を遵守します。
						</dd>
						<dt>2. お客様からご提供いただく情報について</dt>
						<dd>
							本サービスを利用するために、または本サービスの利用を通じてお客様からご提供いただく情報は、本アプリを通じてお客様が入力または送信した情報で、以下の情報が含まれます。<br>
							・お客様の氏名、生年月日、ご連絡先等<br>
							・お客様がご利用になった本サービスの内容、日時、回数などのご利用内容・履歴・状況に関する情報<br>
							・お客様が本サービスに投稿した写真、動画、テキストのコンテンツ及びアクセス情報<br>
							・お客様の端末情報（お客様の識別に係る情報、通信サービス上の行動履歴、その他お客様のスマートフォン、PC等の端末においてお客様またはお客様の端末に関連して生成または蓄積された情報）<br>
							・その他本アプリで取得される、お客様に関する一切の情報<br>
						</dd>
						<dt>3. 個人情報を収集・利用する目的</dt>
						<dd>
							当社が個人情報を収集・利用する目的は、以下のとおりです。<br>
							・当社が販売する商品、提供するサービス、実施するキャンペーン等に関する情報提供のため<br>
							・取得した属性情報、閲覧・購買履歴等を分析してお客様の趣向に応じた情報提供、コンテンツ、クーポン、広告を配信するため<br>
							・当社が提供するサービスに関連する規約やポリシー等(以下「規約等」といいます)に違反する行為に対応するため<br>
							・当社が提供するサービスを通じた取引、お問い合わせ、その他本サービスに関連したお客様への連絡のため<br>
							・当社が現在提供しているサービスまたは将来提供を検討しているサービスに関するマーケティング活動のため<br>
							・当社の商品開発およびサービス改善の統計データとして利用するため<br>
						</dd>
						<dt>4. 個人情報の適正な取得</dt>
						<dd>
							当社は、適正に個人情報を取得し、偽りその他不正の手段により取得しません。
						</dd>
						<dt>5. 個人情報の安全管理</dt>
						<dd>
							当社は、個人情報の紛失、破壊、改ざん及び漏洩等のリスクに対して、個人情報の安全管理が図られるよう、当社の従業員に対し、必要かつ適切な監督を行います。
						</dd>
						<dt>6. 個人情報の第三者提供</dt>
						<dd>
							当社は、個人情報保護法その他法令に基づき第三者への提供が認められる場合を除いて、あらかじめお客様の同意を得ることなく、第三者に個人情報を提供することはありません。
						</dd>
						<dt>7. 個人情報の開示・訂正・削除等</dt>
						<dd>
							お客様は、当社が保有する個人情報について、利用目的の通知の請求、開示、内容の訂正、追加、削除、利用の停止、消去または第三者への提供の停止を請求することができます。
						</dd>
						<dt>8. プライバシーポリシーの変更</dt>
						<dd>
							本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、お客様に通知することなく、変更することができるものとします。<br>
							当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本アプリに掲載したときから効力を生じるものとします。<br>
						</dd>

						<dt>9. お問い合わせ窓口</dt>
						<dd>
						本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。<br>

						会社名 {{shop_name}}<br>
						問い合わせ先 {{tel}}<br>
						</dd>
	
						<p class="si">附則<br> 本規約は2023年8月20日から実施します。
						</p>
					</dl>
				</div>

			</v-container>
		</v-content>
	</v-app>
</template>

<script>
export default {
	data: () => ({
			shop_name: null,
  }),
  async created() {
    var shop_id = this.getUrlGetParam('shop_id')

    if(!shop_id){
      this.init = this.storageGet('*')
      shop_id = this.init.sid
    }

    try {
      //ページ表示に必要な情報を取得
      var shopReq = { params: {
        sid: shop_id
      }}
      var shopRes = await this.apiCall('/user/shop', shopReq)

      this.shop_name = shopRes.corporate_name
      this.tel = shopRes.tel

    } catch(e) {
      this.callDialog('エラー', shopRes.message, 3);
    }
  }
}
</script>

<style scoped>
h1 {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: #333;
	margin-bottom: 20px;
}

.rule {
	padding-top: 10px;
}

dl {
	font-size: 13px;
}

dt {
	font-family: YuGothic;
	font-weight: bold;
	font-size: 16px;
	text-align: center;
	color: #333;
	margin: 30px 0 10px;
}

.si {
	margin-top: 30px;
}
</style>
